import { topicsData } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">{topicsData.title}</h2>
          <p className="text-sm text-foreground-500">{topicsData.subtitle}</p>
        </div>
        <div className="flex flex-wrap justify-center gap-3">
          {topicsData.items.map((item, idx) => (
            <span
              key={idx}
              className="inline-flex items-center gap-2 px-4 py-2.5 bg-background-100 border border-background-200 rounded-full hover:border-primary-300 hover:bg-primary-50 transition-colors cursor-pointer group"
            >
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">{item.name}</span>
              <span className="text-xs text-accent-600 font-medium whitespace-nowrap">{item.heat}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}